import { apiHelper } from '@/utils'
import { API } from '@/constants'
import { sharedHelper } from '@/utils';

export const companyTypeService = {
    getAllTypes,
    getType,
    updateType,
    updateTypeStatus,
    createType 
};

const MODULE = {
    TYPE: 'company-types',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllTypes(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })
    return apiHelper(API_URL).get(`/${MODULE.TYPE}`, requestOptions)
}

export function getType(id) {

    return apiHelper(API_URL).get(`/${MODULE.TYPE}/${id}`)
}

export function updateType(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData,'name', data.name);
    formData.append('_method', "put");
    
    if (data.logo instanceof File) {
        formData.append('logo', data.logo);
      }

    return apiHelper(API_URL).post(`/${MODULE.TYPE}/${data.id}`, formData)     
}

export function createType(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData,'name', data.name);
    
    if (data.logo instanceof File) {
        formData.append('logo', data.logo);
      }

    return apiHelper(API_URL).post(`/${MODULE.TYPE}`, formData)
}

export function updateTypeStatus(data) {
    
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.TYPE}/${data.id}`, requestOptions)
}

